var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarkerBig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 151,
    viewBox: "0 0 101 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0923 0.594788C22.509 0.594788 0.0922852 24.2531 0.0922852 53.3282C0.0922852 63.1532 2.67582 72.7449 7.59249 81.0615L47.2592 148.52C48.0092 149.811 49.3419 150.595 50.7586 150.595H50.842C52.2587 150.578 53.5924 149.77 54.3424 148.462L93.0092 80.3449C97.6758 72.2032 100.092 62.8615 100.092 53.3282C100.092 24.2531 77.6756 0.594788 50.0923 0.594788Z",
    fill: "#D73A1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7504 50.884C71.4907 50.4255 71.0028 50.1412 70.4758 50.1412H51.2837L54.5012 25.5566C54.5066 25.5055 54.5094 25.4543 54.5094 25.4029C54.5094 24.5946 53.8442 23.9294 53.0359 23.9294C52.5379 23.9294 52.0724 24.1819 51.8008 24.5993L28.4612 65.4895C28.3193 65.7202 28.2441 65.9858 28.2441 66.2567C28.2441 67.0603 28.9055 67.7216 29.7091 67.7218H48.6144L46.0645 92.3433C46.0616 92.3807 46.0601 92.4182 46.0601 92.4557C46.0601 93.2641 46.7254 93.9294 47.534 93.9294C48.0383 93.9294 48.5089 93.6707 48.7788 93.2448L71.7328 52.359C72.0034 51.9068 72.0101 51.3423 71.7504 50.884Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerBig);
export default __webpack_public_path__ + "static/media/marker_big.db6af900ec04f5d2149e6a7cb825f809.svg";
export { ForwardRef as ReactComponent };